<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @set-vehicle="setVehicle"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchOperations="(type) => $refs.main.batchOperations(type)"
        @batchAddFee="$refs.main.addFee()"
        @set-vehicle="batchSetVehicle"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <SetVehicle
      :visible.sync="setVehicleOptions.visible"
      :listSoBillCode="setVehicleOptions.listSoBillCode"
      :listSoBillDetailCode="setVehicleOptions.listSoBillDetailCode"
      @reload="setVehicleReload"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header'
import SetVehicle from '../set-vehicle'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageMain, PageHeader, SetVehicle },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      setVehicleOptions: { visible: false },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .finSoBillDetailMergeListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchSetVehicle() {
      const $main = this.$refs.main
      const data = this.$refs.main.getTableCheckedData()
      const detail = $main.getTableDetailCheckedData()

      const listSoBillCode = data?.map((row) => row.soBillCode) || []
      const listSoBillDetailCode = detail?.map((row) => row.soBillDetailCode) || []

      const code = listSoBillCode.concat(listSoBillDetailCode)
      if (!code || !code.length) {
        this.$message({ message: '请选择您要操作的数据！', type: 'warning' })
        return
      }

      this.setVehicleOptions = {
        visible: true,
        listSoBillCode,
        listSoBillDetailCode,
      }
    },
    setVehicle({ soBillDetailCode }) {
      this.setVehicleOptions = {
        visible: true,
        listSoBillDetailCode: [soBillDetailCode],
      }
    },
    setVehicleReload() {
      this.reload()
      this.$refs.main.removeCheckBox()
    },
  },
}
</script>
